import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { BookUser, FilePenLine, FileStack, ReceiptEuro, Users, Building2, Tag } from 'lucide-react'

export default function Dashboard() {
    const { t } = useTranslation()

    return (
        <Container className='p-1 py-5 p-md-5'>
            <Row>
                <Col>
                    <div className='sd-label-dashboard'>{t('welcome')}</div>
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col>
                    <h3>{t('subwelcome')}</h3>
                </Col>
            </Row>
            <Row>
                <Col xs={6} lg={3} className='my-3'>
                    <Link to={`/${t("url.admin")}/${t("url.clients")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center p-4'>
                                <BookUser size={48} className="m-2" />
                                <h4>{t('Clients')}</h4>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={6} lg={3} className='my-3'>
                    <Link to={`/${t("url.admin")}/${t("url.policies")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center p-4'>
                                <FilePenLine size={48} className="m-2" />
                                <h4>{t('Policies')}</h4>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={6} lg={3} className='my-3'>
                    <Link to={`/${t("url.admin")}/${t("url.sinesters")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center p-4'>
                                <img src="/images/sinester.svg" alt="example" className="m-2" width={48} height={48}/>
                                <h4>{t('Sinesters')}</h4>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={6} lg={3} className='my-3'>
                    <Link to={`/${t("url.admin")}/${t("url.receipts")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center'>
                                <ReceiptEuro size={48} className="m-2" />
                                <h4>{t('Receipts')}</h4>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col xs={6} lg={3} className='my-3'>
                    <Link to={`/${t("url.admin")}/${t("url.users")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center p-4'>
                                <Users size={48} className="m-2" />
                                <h4>{t('Users')}</h4>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={6} lg={3} className='my-3'>
                    <Link to={`/${t("url.admin")}/${t("url.documentsManagement")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center p-4'>
                                <FileStack size={48} className="m-2" />
                                <h4>{t('Documents')}</h4>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={6} lg={3} className='my-3'>
                    <Link to={`/${t("url.admin")}/${t("url.companiesManagement")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center p-4'>
                                <Building2 size={48} className="m-2" />
                                <h4>{t('Companies')}</h4>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col xs={6} lg={3} className='my-3'>
                    <Link to={`/${t("url.admin")}/${t("url.categoriesManagement")}`} className='dashboard'>
                        <Card>
                            <Card.Body className='text-center p-4'>
                                <Tag size={48} className="m-2" />
                                <h4>{t('Categories')}</h4>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
}